import { render } from "./CarbonNeutrality.vue?vue&type=template&id=45785830&scoped=true"
import script from "./CarbonNeutrality.vue?vue&type=script&lang=js"
export * from "./CarbonNeutrality.vue?vue&type=script&lang=js"

import "./CarbonNeutrality.vue?vue&type=style&index=0&id=45785830&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45785830"]])

export default __exports__